//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { date } from 'quasar'
import { axiosGet } from '../../axios/axios.js'
import VehicleProvisionStatisticsTable from './VehicleProvisionStatisticsTable.vue'

function prepareMonthStatisticsRecords (monthStatistics, future) {
  const futureRecords = []
  const records = []
  monthStatistics.futureRecords = futureRecords
  monthStatistics.records = records

  if (monthStatistics.workShifts) {
    for (const record of monthStatistics.workShifts.reverse()) {
      record.type = 'dayWorkShift'
      record.name = date.formatDate(record.dateTime, 'DD.MM.YYYY') + getIntervalTypeNameSuffix(record)
      if (record.future) {
        record.trClass = ['bg-white', 'text-grey-9']
        futureRecords.push(record)
      } else {
        record.trClass = []
        if (record.intervalType == 'day') {
          record.trClass.push('text-green-7')
        } else {
          record.trClass.push('text-yellow-9')
        }
        if (record.dayNumber % 2 == 1) {
          record.trClass.push('bg-amber-1')
        } else {
          record.trClass.push('bg-red-1')
        }
        records.push(record)
      }
    }
  }

  const onlyFutureRecords = future || futureRecords.length !== 0 && records.length === 0
  if (!onlyFutureRecords) {
    const hasDayRecords = monthStatistics.workShifts != null

    for (const record of monthStatistics.summaryWorkShifts.reverse()) {
      record.type = 'summaryWorkShift'
      record.name = 'Итого' + getIntervalTypeNameSuffix(record)
      if (hasDayRecords) {
        record.trClass = ['bg-teal-3', 'text-grey-9']
      } else {
        record.trClass = ['text-grey-9']
        if (record.intervalType == 'day') {
          record.trClass.push('bg-white')
        } else {
          record.trClass.push('bg-light-blue-1')
        }
      }

      records.push(record)
    }

    for (const record of monthStatistics.averageWorkShifts.reverse()) {
      record.type = 'averageWorkShift'
      record.name = 'Среднее в ' + getIntervalTypeName(record)
      if (hasDayRecords) {
        record.trClass = ['bg-teal-3', 'text-grey-9']
      } else {
        record.trClass = ['text-grey-9']
        if (record.intervalType == 'day') {
          record.trClass.push('bg-white')
        } else {
          record.trClass.push('bg-light-blue-1')
        }
      }

      record.orderedDailyCount = ceilAverage(record.orderedDailyCount)
      record.idlingDailyCount = ceilAverage(record.idlingDailyCount)
      record.orderedAdditionalCount = ceilAverage(record.orderedAdditionalCount)
      record.otherOrderedAdditionalCount = ceilAverage(record.otherOrderedAdditionalCount)

      records.push(record)
    }
  }
}

function getIntervalTypeName (record) {
  return record.intervalType == 'day' ? 'День' : 'Ночь'
}

function getIntervalTypeNameSuffix (record) {
  return record.intervalType == 'day' ? ' (Д)' : ' (Н)'
}

function ceilAverage (value) {
  if (value != null) {
    return Math.ceil(value * 100) / 100
  }
  return null
}

export default {
  name: 'VehicleProvisionStatistics',
  components: {
    VehicleProvisionStatisticsTable
  },
  data: function () {
    return {
      loadingFull: false,
      hasChanges: false,

      // ===

      intervalType: null,
      intervalTypeOptions: [
        {
          label: 'Месяц',
          value: 'month'
        },
        {
          label: 'Год',
          value: 'year'
        }
      ],

      year: null,
      yearOptions: null,

      // oldInterval: { years: [], months: [], days: {} },
      // yearsChart: [],
      // currentYearsChart: [],
      // optionsYears: [],
      // currentGroupInterval: [],
      // yearTab: 'year-',

      month: null,
      monthOptions: [
        { label: 'Январь', shortLabel: 'ЯНВ', value: 0 },
        { label: 'Февраль', shortLabel: 'ФЕВ', value: 1 },
        { label: 'Март', shortLabel: 'МАР', value: 2 },
        { label: 'Апрель', shortLabel: 'АПР', value: 3 },
        { label: 'Май', shortLabel: 'МАЙ', value: 4 },
        { label: 'Июнь', shortLabel: 'ИЮН', value: 5 },
        { label: 'Июль', shortLabel: 'ИЮЛ', value: 6 },
        { label: 'Август', shortLabel: 'АВГ', value: 7 },
        { label: 'Сентябрь', shortLabel: 'СЕН', value: 8 },
        { label: 'Октябрь', shortLabel: 'ОКТ', value: 9 },
        { label: 'Ноябрь', shortLabel: 'НОЯ', value: 10 },
        { label: 'Декабрь', shortLabel: 'ДЕК', value: 11 }
      ],

      // ===

      monthsStatistics: null
    }
  },
  computed: {
  },
  created: function () {
    const currentDate = new Date()
    const currentYear = currentDate.getFullYear()
    const fromYear = 2023
    const yearOptions = []
    for (let year = fromYear; year <= currentYear; year++) {
      yearOptions.push({ label: String(year), value: year })
    }
    this.yearOptions = yearOptions

    const query = this.$route.query
    if (query && query.intervalType) {
      this.intervalType = query.intervalType
    } else {
      this.intervalType = 'month'
    }
    if (query && query.year) {
      this.year = Number(query.year)
    } else {
      this.year = currentYear
    }
    if (query && query.month) {
      this.month = Number(query.month)
    } else {
      this.month = currentDate.getMonth() // currentMonthIndex
    }

    this.load()
    // this.hasChanges = true

    if (!query || !query.intervalType || !query.year || this.intervalType === 'month' && !query.month) {
      this.updateQuery()
    }
  },
  methods: {
    onReload: function () {
      if (this.hasChanges) {
        this.updateQuery()
      }

      this.load().then(() => {
        this.hasChanges = false
      })
    },
    load: function () {
      const params = new URLSearchParams()
      params.set('intervalType', this.intervalType)
      params.set('year', this.year)
      if (this.intervalType === 'month') {
        params.set('month', this.month)
      }

      this.loadingFull = true
      return axiosGet({
        url: '/service/delta/vehicleProvision/statistics/get?' + params.toString(),
        onSuccess: response => {
          const result = response.data.result
          if (this.intervalType === 'month') {
            this.monthsStatistics = this.prepareMonthsStatistics([result], this.monthOptions)
          } else {
            this.monthsStatistics = this.prepareMonthsStatistics(result.monthsStatistics, this.monthOptions)
          }
        },
        onFailure: 'Ошибка получения статистики использования автовышек',
        throws: true
      }).finally(() => {
        this.loadingFull = false
      })
    },
    prepareMonthsStatistics: function (monthsStatistics, monthOptions) {
      for (const monthStatistics of monthsStatistics) {
        monthStatistics.label = monthOptions[monthStatistics.monthNumber].label
        monthStatistics.showLabel = this.intervalType === 'year'
        monthStatistics.intervalType = this.intervalType

        prepareMonthStatisticsRecords(monthStatistics, monthStatistics.future)
      }

      return monthsStatistics.reverse()
    },

    onIntervalTypeInput: function () {
      this.hasChanges = true
    },
    onYearInput: function () {
      this.hasChanges = true
    },
    onMonthInput: function () {
      this.hasChanges = true
    },

    updateQuery: function () {
      const query = {}
      query.intervalType = this.intervalType
      query.year = String(this.year)
      if (this.intervalType === 'month') {
        query.month = String(this.month)
      }
      this.$router.replace({ path: this.$route.path, query: query })
    }
  }
}

